module.exports = __webpack_public_path__ + "img/245.f1f87bb5.png";